import axios from "axios";
import React, { useEffect, useState } from "react";

import { ReactComponent as CloseIcon } from "../../../assets/Home/closeIcon.svg";
import styles from "../style.module.css";

const LookUpReceipt = () => {
	const [showTaxCalcResult, setShowTaxCalcResult] = useState(false);
	const [loading, setLoading] = useState(false);
	const [receiptID, setReceiptID] = useState("");
	const [alert, setAlert] = useState({
		showing: false,
		type: null,
		message: ""
	});

	const handleGetReceipt = async (e) => {
		e.preventDefault();
		if (!!receiptID && !isNaN(receiptID)) {
			try {
				setLoading(true);
				const taxResult = await axios
					.get(`taxcalculator/${receiptID}`)
					.then((res) => (res.data || {}).data);
				if (taxResult) {
					setShowTaxCalcResult(true);
					setLoading(false);
					setAlert({
						showing: true,
						type: "error",
						message: "ChargeTaxSpread found"
					});
				}
			} catch (err) {
				setLoading(false);
				console.error(err);
				setAlert({
					showing: true,
					type: "error",
					message: "Tax Calculation not successful."
				});
			}
		}
	};

	useEffect(() => {
		const delay = setTimeout(
			() =>
				setAlert({
					showing: false,
					type: null,
					message: ""
				}),
			3000
		);

		return () => clearTimeout(delay);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [!!alert.showing]);

	return (
		<>
			<div className="container demo">
				<div
					className="modal right fade"
					id="lookUpReceipt"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="LookUpReceipt"
				>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className={`modal-body ${styles.modal__body}`}>
								<div>
									<CloseIcon
										type="button"
										data-dismiss="modal"
										style={{ cursor: "pointer" }}
									/>
									<h3>Lookup Receipt</h3>
								</div>
								{!showTaxCalcResult ? (
									<>
										<label htmlFor="receiptField">
											Receipt ID
											<span className="text-danger">
												*
											</span>
										</label>
										<div className="input-group">
											<span
												className="input-group-addon"
												id="sizing-addon1"
											>
												&#8358;
											</span>
											<input
												type="text"
												id="receiptField"
												className="form-control"
												placeholder="Receipt"
												aria-describedby="sizing-addon2"
												onChange={(e) =>
													setReceiptID(e.target.value)
												}
											/>
										</div>

										<button
											className={`btn btn-success ${styles.my_30}`}
											type="button"
											disabled={!receiptID}
											onClick={handleGetReceipt}
										>
											{loading
												? "Loading..."
												: "Get Receipt"}
										</button>
									</>
								) : (
									<>
										<p>
											Instantly estimate your tax due with
											the calculator.
										</p>

										<br />
										<h4>Income-to-Tax</h4>
										<table className="table table-bordered">
											<thead>
												<tr>
													<th>Total Income</th>
													<th>₦50,000,000.00</th>
												</tr>
											</thead>
										</table>
										<br />

										<table className="table table-bordered">
											<thead>
												<tr>
													<th>
														Annual Taxable Income
													</th>
													<th>Rate</th>
													<th>
														{"Tax Calculated(₦)"}
													</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>First NGN 300,000</td>
													<td>7%</td>
													<td>₦21,000.00</td>
												</tr>
												<tr>
													<td>Next NGN 300,000</td>
													<td>11%</td>
													<td>₦21,000.00</td>
												</tr>
												<tr>
													<td>Next NGN 300,000</td>
													<td>11%</td>
													<td>₦21,000.00</td>
												</tr>
												<tr>
													<td>Next NGN 300,000</td>
													<td>11%</td>
													<td>₦21,000.00</td>
												</tr>
												<tr>
													<td>Next NGN 300,000</td>
													<td>11%</td>
													<td>₦21,000.00</td>
												</tr>
												<tr>
													<td>Above NGN 3,200,000</td>
													<td>24%</td>
													<td>₦768,000.00</td>
												</tr>
												<tr>
													<td>Overflow</td>
													<td>24%</td>
													<td>₦21,000.00</td>
												</tr>
												<tr>
													<td
														style={{
															padding: "8px"
														}}
													>
														{" "}
													</td>
													<td> </td>
													<td> </td>
												</tr>
											</tbody>
											<tfoot>
												<tr>
													<th colSpan={2}>Total</th>
													<th>₦21,000.00</th>
												</tr>
											</tfoot>
										</table>
										<br />
										<table className="table table-bordered">
											<thead>
												<tr>
													<th>Income Tax</th>
													<th>₦500,000.00</th>
												</tr>
											</thead>
											<tfoot>
												<tr>
													<th>
														Total calculated annual
														Tax
													</th>
													<th>₦12,292,000.00</th>
												</tr>
												<tr>
													<th>
														Total calculated Monthly
														Tax
													</th>
													<th>₦12,292,000.00</th>
												</tr>
											</tfoot>
										</table>
										<br />
										<br />
										<div
											className={
												styles.modal__button__wrapper
											}
										>
											<button
												className={`${styles.modal__button} btn`}
											>
												Check again
											</button>
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default LookUpReceipt;
